import { render, staticRenderFns } from "./RenunciaTable.html?vue&type=template&id=e6c0a98a&external"
import script from "./RenunciaTable.vue?vue&type=script&lang=js"
export * from "./RenunciaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports